import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Lock } from "@phosphor-icons/react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vm_token", data.token);
      toast.success("Bem-vindo(a) de volta!");
      nav("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Falha no login.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-vm-bg text-vm-fg flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex h-14 w-14 rounded-full bg-vm-gold items-center justify-center mb-5">
            <Lock size={26} weight="duotone" className="text-vm-bg" />
          </div>
          <h1 className="font-serif text-3xl">Área Administrativa</h1>
          <p className="text-sm text-vm-mutedFg mt-2">VM Piabetá Shopping Center</p>
        </div>
        <form onSubmit={submit} className="space-y-6 bg-vm-surface border border-vm-border rounded-2xl p-8">
          <div>
            <label className="text-xs tracking-widest uppercase text-vm-mutedFg">E-mail</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-vm-border focus:border-vm-gold outline-none py-3 transition-colors" placeholder="admin@vmpiabeta.com.br" data-testid="admin-email" />
          </div>
          <div>
            <label className="text-xs tracking-widest uppercase text-vm-mutedFg">Senha</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border-b border-vm-border focus:border-vm-gold outline-none py-3 transition-colors" placeholder="••••••••" data-testid="admin-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-sweep relative z-0 w-full bg-vm-gold text-vm-bg hover:text-vm-bg font-semibold py-3.5 rounded-full disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
        <a href="/" className="block text-center text-sm text-vm-mutedFg mt-6 hover:text-vm-gold transition-colors">← Voltar ao site</a>
      </motion.div>
    </div>
  );
}
